import axiosInstance from "../config/axios";
import { privateList } from "../middlewares/transform/chat";
import AppStorage from "./AppStorage";

export default class ActivityService {

    async getQuickActivityData(data: any) {
        try {
            const activity = await axiosInstance.get("trainee/get_quick_activity_data", data)
            return activity;
        }
        catch (error) {
            console.log(error)
        }
    }


    async getSegmentActivity(data: any) {
        try {
            const segment = await axiosInstance.get("trainee/get_segment_activity_for_trainee", data)
            return segment;
        }
        catch (error) {
            console.log(error)
        }
    }
}